export const requireMintProvisioning = (patientMintIdentifier, useMintReferralWindow) => {
  if (useMintReferralWindow && !!patientMintIdentifier) {
    return true;
  }

  return false;
};
